import Vue from 'vue'

// 从本地存储获取 token
export function getToken () {
  return Vue.ls.get('ACCESS_TOKEN')
}

// 设置 token 到本地存储
export function setToken (token) {
  return Vue.ls.set('ACCESS_TOKEN', token)
}

// 移除 token
export function removeToken () {
  return Vue.ls.remove('ACCESS_TOKEN')
}



// WEBPACK FOOTER //
// ./src/utils/auth.js